import { useState } from 'react'
import { SegmentedTabs } from '@/components/ui/SegmentedTabs'
import { TemplateGallery } from '@/components/templates/TemplateGallery'
import { WorkflowList } from '@/components/learned/WorkflowList'
import { ActivityPulse } from '@/components/pulse/ActivityPulse'
import type { ActivityEvent, Workflow } from '@/types/dashboard'

type AutoTab = 'flows' | 'templates' | 'activity'

interface Props {
  workflows: Workflow[]
  domains: string[]
  activity: ActivityEvent[]
  domainFilter: string
  proposingId: string | null
  onDomainFilter: (d: string) => void
  onPropose: (id: string) => void
  onDetect: () => void
  onCopy: (id: string) => void
  onApplied: () => void
  onToast: (msg: string, kind?: 'ok' | 'err' | '') => void
}

export function AutomationsWorkbench(props: Props) {
  const [tab, setTab] = useState<AutoTab>('flows')

  return (
    <section className="block tab-block">
      <div className="section-head">
        <div>
          <h2>Automations</h2>
          <p>Learned flows, starter templates, and live capture stream.</p>
        </div>
      </div>

      <SegmentedTabs
        ariaLabel="Automations"
        value={tab}
        onChange={setTab}
        tabs={[
          { id: 'flows', label: 'Flows', count: props.workflows.length },
          { id: 'templates', label: 'Templates' },
          { id: 'activity', label: 'Activity', count: props.activity.length }
        ]}
      />

      {tab === 'flows' ? (
        <WorkflowList
          workflows={props.workflows}
          domains={props.domains}
          domainFilter={props.domainFilter}
          proposingId={props.proposingId}
          onDomainFilter={props.onDomainFilter}
          onPropose={props.onPropose}
          onDetect={props.onDetect}
          onCopy={props.onCopy}
          embedded
        />
      ) : null}

      {tab === 'templates' ? (
        <TemplateGallery onApplied={props.onApplied} onToast={props.onToast} embedded />
      ) : null}

      {tab === 'activity' ? <ActivityPulse activity={props.activity} embedded /> : null}
    </section>
  )
}
